import { render, staticRenderFns } from "./wyList.vue?vue&type=template&id=67b05ffc&scoped=true"
import script from "./wyList.vue?vue&type=script&lang=js"
export * from "./wyList.vue?vue&type=script&lang=js"
import style0 from "./wyList.vue?vue&type=style&index=0&id=67b05ffc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b05ffc",
  null
  
)

export default component.exports